export default __webpack_public_path__ + "static/sstby-eefdfcd649b29df10a83181372ce5ee4.png";